import React, { forwardRef, ReactNode } from 'react';
import {
  Alert as ChakraAlert,
  AlertProps,
  AlertIcon,
  AlertTitle,
} from '@chakra-ui/react';

interface Props extends Omit<AlertProps, `css`> {
  children?: ReactNode;
}

export const Alert = forwardRef<HTMLDivElement, Props>(
  (props, ref): JSX.Element => {
    return (
      <ChakraAlert ref={ref} {...props}>
        <AlertIcon />
        <AlertTitle>{props.children}</AlertTitle>
      </ChakraAlert>
    );
  }
);
export type { Props as AlertProps };
